const Status = {
  ACTIVE: 1,
  IN_ACTIVE: 0,
  ACTIVE_TEXT: "Active",
  IN_ACTIVE_TEXT: "InActive"
};

export default Status;
